import React from 'react';
import TextField from 'components/TextField';
import { MenuItem } from '@material-ui/core';
import Section from '../../components/Section';
import { Container, Row, Column, WrapperInputCustom } from './styles';

function ProdutoPredominante({ formik, edit, view }) {
  return (
    <Section title="Produto predominante">
      <Container>
      <Row>
        <Column>
          <WrapperInputCustom>
            <TextField
              label="Tipo de carga"
              name="cargo_type"
              select
              value={formik.values.cargo_type || ''}
              onChange={(e) => {
                const value = e.target.value;
                formik.setFieldValue('cargo_type', value);
                formik.setFieldTouched('cargo_type', true);
                formik.setFieldError('cargo_type', '');
                console.log('Tipo de carga selecionado:', value);
              }}
              onBlur={formik.handleBlur}
              error={formik.touched.cargo_type && Boolean(formik.errors.cargo_type)}
              helperText={formik.touched.cargo_type && formik.errors.cargo_type}
              disabled={view}
              fullWidth
              color="secondary"
            >
              <MenuItem value="">Selecione</MenuItem>
              <MenuItem value="Carga Geral">Carga Geral</MenuItem>
              <MenuItem value="Solta">Solta</MenuItem>
              <MenuItem value="Unitizada">Unitizada</MenuItem>
              <MenuItem value="Carga a Granel">Carga a Granel</MenuItem>
              <MenuItem value="Carga Neogranel">Carga Neogranel</MenuItem>
              <MenuItem value="Carga Frigorificada">Carga Frigorificada</MenuItem>
              <MenuItem value="Carga Perigosa">Carga Perigosa</MenuItem>
            </TextField>
          </WrapperInputCustom>
        </Column>

        <Column>
          <WrapperInputCustom>
            <TextField
              label="Descrição do produto *"
              name="descricao_produto"
              placeholder="Descrição do produto"
              value={formik.values.descricao_produto || ''}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              disabled={view}
              error={
                formik.touched.descricao_produto &&
                Boolean(formik.errors.descricao_produto)
              }
              helperText={formik.touched.descricao_produto && formik.errors.descricao_produto}
              fullWidth
              color="secondary"
            />
          </WrapperInputCustom>
        </Column>
      </Row>

      <Row>
        <Column>
          <WrapperInputCustom>
            <TextField
              label="GTIN"
              name="gtin"
              placeholder="GTIN"
              value={formik.values.gtin || ''}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              disabled={view}
              fullWidth
              color="secondary"
            />
          </WrapperInputCustom>
        </Column>

        <Column>
          <WrapperInputCustom>
            <TextField
              label="NCM"
              name="ncm"
              placeholder="NCM"
              value={formik.values.ncm || ''}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              disabled={view}
              fullWidth
              color="secondary"
            />
          </WrapperInputCustom>
        </Column>
      </Row>
      </Container>
    </Section>
  );
}

export default ProdutoPredominante;

